import React, { useEffect, createContext } from 'react'
import { ApexAuth } from 'apex-ui-services'
import { AuthorizationRequestData } from '@Types'
import { connect } from 'react-redux'
import { RootState } from '../../store'
import { legit } from 'apex-legit-service'
import { LEGIT_SERVICE_CONFIG, LOGOUT_REDIRECT_URI } from '../../constants/okta'
import { Dispatch } from 'redux'
import { useOktaAuth } from '@okta/okta-react'
import { ALL_REQUESTED_PERMISSIONS, convertToAuthRequest } from '../../constants'
import { AuthorizationState } from '@Types'
import isNil from 'lodash.isnil'
import { handleFeatureFlag } from '../../utils'
import { clearRumUser } from '../../utils/datadog'

interface FeatureFlag {
  positionJournal: boolean
  // <featureName>: boolean
}
export interface AuthContextProps {
  handleSignout: () => void
  showAppContent: boolean
  featureFlag: FeatureFlag
}

export interface AuthProviderProps {
  getAuth: (payload: AuthorizationRequestData[]) => void
  auth: AuthorizationState
  getLegacyUrl: () => void
  showAppContent: boolean
  logout: (params: { apexUser: boolean }) => void
  clearLoginType: () => void
  children: JSX.Element | JSX.Element[]
  featureFlag: FeatureFlag
}

export const AuthContext = createContext<AuthContextProps | {}>({})

const AuthProviderComponent = ({
  getAuth,
  auth,
  getLegacyUrl,
  showAppContent,
  logout,
  clearLoginType,
  children,
  featureFlag
}: AuthProviderProps) => {
  const { oktaAuth } = useOktaAuth()

  useEffect(() => {
    if (isNil(auth?.authorization) && !auth?.hasBeenAsked) {
      getAuth(convertToAuthRequest(ALL_REQUESTED_PERMISSIONS))
    }
    getLegacyUrl()
    handleFeatureFlag()
    // eslint-disable-next-line
  }, [])
  const oktaLogout = async () => {
    await oktaAuth.signOut({
      postLogoutRedirectUri: LOGOUT_REDIRECT_URI
    })
  }

  const handleSignout = () => {
    if (showAppContent) {
      const params = { apexUser: false }
      oktaLogout()
      logout(params)
      clearLoginType()
      clearRumUser()
    }
  }
  return <AuthContext.Provider value={{ handleSignout, showAppContent, featureFlag }}>{children}</AuthContext.Provider>
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getAuth: ApexAuth.authorization.actions.createAuthorization.request,
  logout: (params: { apexUser: boolean }) => {
    dispatch(
      legit.logout(LEGIT_SERVICE_CONFIG, {
        ...params
      })
    )
  },
  clearLoginType: () => dispatch(ApexAuth.loginType.actions.clearLoginType()),
  getLegacyUrl: (ApexAuth.legacyUrl.actions.fetchLegacyUrl.request as unknown) as () => void // to get around a type issue with typesafe-actions undefined for no params
})

const mapStateToProps = (state: RootState) => ({
  auth: {
    hasBeenAsked: ApexAuth.authorization.selectors.authorizationHasBeenAsked(state),
    authorization: ApexAuth.authorization.selectors.authorizations(state),
    error: ApexAuth.authorization.selectors.error(state)
  },
  showAppContent: legit.selectors.selectShowLoginUI(state) === legit.LOGIN_UI_HIDE,
  featureFlag: handleFeatureFlag()
})

export const AuthProvider = connect(mapStateToProps, mapDispatchToProps)(AuthProviderComponent)
